import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { router } from "../app/services/router";
import { AccountSignInForm } from "../features/account/AccountSignInForm";
import { SecurityWarningDialog } from "../features/security/SecurityWarningDialog";
import { Button } from "../features/shared/Button";
import { Separator } from "../features/shared/Separator";
import { SignUpPage } from "./SignUpPage";
import { AuthenticationPage } from "./shared/AuthenticationPage";

export const SignInPage = () => {
  const { t } = useTranslation();
  const { meta, nav, title } = t("pages.SignInPage") as unknown as {
    meta: { title: string };
    nav: { forgotPassword: { text: string }; signUp: { text: string } };
    title: string;
  };

  return (
    <>
      <AuthenticationPage
        dataLayer={{
          categorie_page: "homepage",
          nom_page: "pre-home",
          virtualpagetitle: "Homepage déconnectée",
        }}
        meta={meta}
        title={title}
      >
        <AccountSignInForm />
        <Button
          asChild
          dataLayer={{
            eventAction: "clic",
            eventCategory: "pre_home",
            eventLabel: "mot_de_passe_oublie",
          }}
          icon="next"
          variant="text"
        >
          <Link to={router.getTo("authenticationForgotPassword")}>
            {nav.forgotPassword.text}
          </Link>
        </Button>
        <Separator variant="or" />
        <Button
          asChild
          dataLayer={{
            eventAction: "clic",
            eventCategory: "pre_home",
            eventLabel: "creer_un_compte",
          }}
          variant="action"
        >
          <Link to={router.getTo("authenticationSignUp")}>
            {nav.signUp.text}
          </Link>
        </Button>
      </AuthenticationPage>
      <SignUpPage />
      <SecurityWarningDialog />
    </>
  );
};
